import React from 'react';
import { Skeleton } from '../../ui/skeleton';

const AccountOverviewSkeleton: React.FC = () => (
  <div className="bitte-bg-[#18181b] bitte-rounded-lg bitte-p-6 bitte-space-y-6">
    {/* Header skeleton */}
    <div className="bitte-flex bitte-justify-center">
      <Skeleton className="bitte-w-32 bitte-h-4" />
    </div>

    <div className="bitte-grid bitte-grid-cols-1 lg:bitte-grid-cols-6 bitte-gap-4 bitte-w-full">
      {/* Left column - Overview */}
      <div className="lg:bitte-col-span-2 bitte-flex bitte-flex-col">
        <Skeleton className="bitte-w-16 bitte-h-2 bitte-mb-3" />
        <div className="bitte-bg-[#292929] bitte-rounded-md bitte-flex-1 bitte-min-h-[300px] bitte-p-4 bitte-space-y-4">
          <Skeleton className="bitte-w-3/4 bitte-h-3" />
          <Skeleton className="bitte-w-20 bitte-h-6" />
          <Skeleton className="bitte-w-16 bitte-h-4" />
          <div className="bitte-grid bitte-grid-cols-2 bitte-gap-4 bitte-mt-8">
            <Skeleton className="bitte-h-16" />
            <Skeleton className="bitte-h-16" />
          </div>
        </div>
      </div>

      {/* Right column - Assets */}
      <div className="lg:bitte-col-span-4 bitte-flex bitte-flex-col">
        <div className="bitte-h-6 bitte-mb-3" />
        <div className="bitte-bg-[#292929] bitte-rounded-md bitte-flex-1 bitte-min-h-[300px] bitte-p-4 bitte-space-y-3">
          {/* Table headers */}
          <div className="bitte-grid bitte-grid-cols-3 bitte-gap-4 bitte-mb-4">
            <Skeleton className="bitte-w-12 bitte-h-2" />
            <Skeleton className="bitte-w-16 bitte-h-2" />
            <Skeleton className="bitte-w-12 bitte-h-2" />
          </div>
          {/* Asset rows */}
          {Array.from({ length: 3 }).map((_, index) => (
            <div
              key={index}
              className="bitte-grid bitte-grid-cols-3 bitte-gap-4 bitte-py-3"
            >
              <div className="bitte-flex bitte-items-center bitte-gap-3">
                <Skeleton className="bitte-w-9 bitte-h-9 bitte-rounded-full" />
                <div className="bitte-space-y-1">
                  <Skeleton className="bitte-w-12 bitte-h-3" />
                  <Skeleton className="bitte-w-16 bitte-h-2" />
                </div>
              </div>
              <Skeleton className="bitte-w-20 bitte-h-3" />
              <div className="bitte-space-y-1">
                <Skeleton className="bitte-w-16 bitte-h-3" />
                <Skeleton className="bitte-w-12 bitte-h-2" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const WelcomeListSkeleton: React.FC<{ title: string }> = ({ title }) => (
  <div className="bitte-flex bitte-gap-2 bitte-flex-col">
    <p className="bitte-text-[10px] bitte-uppercase bitte-font-semibold bitte-text-[#969696]">
      {title}
    </p>
    <div className="bitte-flex bitte-gap-2 bitte-flex-col">
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton key={index} className="bitte-h-8 bitte-w-48" />
      ))}
    </div>
  </div>
);

export const WelcomeAccountOverviewSkeleton: React.FC = () => {
  return (
    <div className="bitte-w-full">
      <AccountOverviewSkeleton />
      <div className="bitte-mt-6 bitte-px-6 bitte-grid bitte-grid-cols-1 md:bitte-grid-cols-2 bitte-gap-4">
        <WelcomeListSkeleton title="QUESTIONS" />
        <WelcomeListSkeleton title="ACTIONS" />
      </div>
    </div>
  );
};
